import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
const useStyles = makeStyles(theme => {
  var _theme$palette, _theme$palette$contra;
  return {
    outOf: {
      marginLeft: 12
    },
    root: {
      height: 8,
      borderRadius: 5,
      marginTop: 5
    },
    colorPrimary: {
      backgroundColor: ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$contra = _theme$palette.contrast) === null || _theme$palette$contra === void 0 ? void 0 : _theme$palette$contra.main) || "#C6C6C630"
    },
    bar: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 5
    }
  };
});
const ProgressBar = ({
  title,
  value,
  outOf = 100,
  showNumericScore = true,
  suffix
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textPrimary"
  }, t(title)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: showNumericScore ? suffix ? 11 : 10 : 12
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    classes: {
      root: classes.root,
      colorPrimary: classes.colorPrimary,
      bar: classes.bar
    },
    value: value + outOf > 0 ? value / outOf * 100 : 0,
    variant: "determinate"
  })), showNumericScore && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: suffix ? 1 : 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.outOf,
    color: "textPrimary"
  }, suffix ? suffix : `${value} / ${outOf}`))));
};
ProgressBar.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  outOf: PropTypes.number,
  showNumericScore: PropTypes.bool,
  suffix: PropTypes.string
};
export default ProgressBar;